module.exports = __webpack_public_path__ + "static/media/cardsort.fc763b5c.png";